import React, { useState, useEffect } from 'react'
import { useSelector } from 'react-redux'
import Icon from 'srcReact/components/icons/Icon'
import styles from './styles.module.scss'
import Button from 'srcReact/components/common2/Button'
import { openInNewTab } from 'srcReact/helpers/utils'
import Pill from 'srcReact/components/common2/Pill'
import ShowMoreCompoents from 'srcReact/components/common2/ShowMoreCompoents'

export default function Info({ t, isGoing, address, description, isMemberOfGroup, isStatic }) {
  const {
    mixr: { mixr },
    common: { isMobile }
  } = useSelector((state) => state)
  const [isShowMore, setIsShowMore] = useState(true)

  useEffect(() => {
    if (!mixr?.is_preview && ((mixr?.status === 'over' && isGoing) || (mixr?.status !== 'over' && isGoing))) {
      setIsShowMore(false)
      return
    }
    setIsShowMore(true)
  }, [mixr?.is_preview, mixr?.status, isGoing])

  return (
    <div className={styles.infoWrapper}>
      {isMemberOfGroup && (
        <div className={`${styles.links} `}>
          {address?.formatted_address?.trim()?.length > 0 && (
            <div className={`${styles.link}  ${styles.linkLocation}`}>
              <Icon name='map24' />
              <a target='_blank' href={`https://maps.google.com?q=${address.latitude},${address.longitude}`}>
                {address.formatted_address}
              </a>
            </div>
          )}
          {!isMobile && mixr && mixr.join_in_link && (
            <Button
              customStyle={`${styles.joinBtn} ${isStatic ? styles.inactive : ''}`}
              text={t('mixrHome.joinCall')}
              size='large'
              iconPosition='start'
              icon={<Icon name='virtualmixr-icon' size='large32' />}
              icon2={<Icon name='arrow-right' size='large32' />}
              handleClick={() => openInNewTab(mixr.join_in_link)}
            />
          )}
        </div>
      )}

      <div className={styles.about}>
        <ShowMoreCompoents isShowMore={isShowMore} setIsShowMore={setIsShowMore}>
          <div dangerouslySetInnerHTML={{ __html: description }} />
          {(mixr?.interests?.length >= 1 || mixr?.expertises?.length >= 0) && (
            <div className={styles.interests}>
              {mixr.group?.type === 'interest' &&
                mixr.interests?.map((i, idx) => (
                  <Pill
                    shared={i.is_common_with_logged_user === 1}
                    selected={true}
                    text={i.name}
                    key={idx}
                    dataId={i.id}
                    askForAddToProfile={i.is_common_with_logged_user === 0}
                  />
                ))}
              {/* While preview, we only maintain mixr.interests and not mixr.expertises */}
              {mixr.group?.type === 'expertise'
                ? mixr.is_preview
                  ? mixr.interests?.map((i, idx) => (
                      <Pill
                        shared={i.is_common_with_logged_user === 1}
                        selected={true}
                        type='expertise'
                        text={i.name}
                        key={idx}
                      />
                    ))
                  : mixr.expertises?.map((i, idx) => (
                      <Pill
                        shared={i.is_common_with_logged_user === 1}
                        selected={true}
                        type='expertise'
                        text={i.name}
                        key={idx}
                      />
                    ))
                : null}
            </div>
          )}
        </ShowMoreCompoents>
      </div>
    </div>
  )
}
